import React from "react";
import styles from "./student-gallery.module.scss";
import SbEditable from "storyblok-react";
import Components from "~components/components";
import { createSpacingClass } from "~/../components/src/components/utils/spacing";

const StudentGallerySection = (props: any) => {
  const { spacing, student_rows, story } = props;
  const contentSpacing = createSpacingClass(spacing);

  return student_rows.length ? (
    <SbEditable content={props}>
      <div
        className={`ef-section ${contentSpacing ? contentSpacing : ""}`}
        style={{ width: "100wv", overflow: "hidden" }}
      >
        {student_rows.map((row: any) => (
          <div key={row._uid} className={`${styles.wrapper} ef-row`}>
            {Components(row, story)}
          </div>
        ))}
      </div>
    </SbEditable>
  ) : null;
};

export default StudentGallerySection;
